// extracted by mini-css-extract-plugin
module.exports = {"EmptySection":"styles_EmptySection__R2Fq9","title":"styles_title__0Hypj","cta":"styles_cta__ifE04"};